module.exports = __webpack_public_path__ + "static/media/kuibishanicon.4ffb8962.webp";